import { z } from 'zod';
import { put, takeEvery } from '@redux-saga/core/effects';
import { reportMessage } from 'lib/error';
import { encoderVideoStatus, encoderAudioStatus, type EncoderStatusData } from 'store/encoder-status/slice';

type EncoderStatusSagaPayload = {
    type: string;
    data: unknown;
};

const encoderStatusDataSchema = z.object({
    messages: z.number(),
    messagesRate: z.number(),
    currentReplicas: z.number(),
    desiredReplicas: z.number(),
});

function* encoderStatusMqttSaga(payload: EncoderStatusSagaPayload) {
    try {
        const { type, data } = payload;
        const [, , assetType] = type.split('/');
        const parsedData = encoderStatusDataSchema.parse(data) as EncoderStatusData;

        switch (assetType) {
            case 'video':
                yield put(encoderVideoStatus(parsedData));
                break;
            case 'audio':
                yield put(encoderAudioStatus(parsedData));
                break;
            default:
        }
    } catch (error) {
        reportMessage({
            message: 'Failed to parse encoder status data',
            error,
        });
    }
}

export default [
    takeEvery((action) => Boolean(action?.type?.match(/^MQTT\/encoder\/.+\/status$/)), encoderStatusMqttSaga),
];
